export default __webpack_public_path__ + "static/media/Tunic of Concealing Shadows.9112fd7b.jpg";